module.exports = __webpack_public_path__ + "static/media/shapes-green.3e64ddd1.png";